import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15c659f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-page" }
const _hoisted_2 = { class: "tab-area" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tab-area-bd" }
const _hoisted_5 = { class: "faq-page-bd" }
const _hoisted_6 = { class: "search-area" }
const _hoisted_7 = { class: "search-area-bd" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/searchicon2-54e33b82b44e3eb01f36bb066464823b.png",
  alt: "",
  class: "search-area-bd__icon"
}, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "faq-page-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "faq-page-link__hd" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/link-arrow-2ba8fde49f33eda50b8d03b35cf48685.svg",
  alt: "",
  class: "faq-page-link__bd"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("我要提问")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VNavBar = _resolveComponent("VNavBar")!
  const _component_VButton = _resolveComponent("VButton")!
  const _component_QuestionList = _resolveComponent("QuestionList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VNavBar, {
      title: "常见问题",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/')))
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['tab-area-item', index === _ctx.tabIndex ? 'cur' : '']),
          onClick: ($event: any) => (_ctx.clickTab(index))
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(tab), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKey) = $event)),
            maxlength: "30",
            placeholder: "搜索问题关键词",
            class: "search-area-bd__ipt",
            onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchQues && _ctx.searchQues(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchKey]
          ]),
          _createElementVNode("img", {
            src: "https://static.wecity.qq.com/miying/Mask-446892b212cbf69be654a141dd097bf4.svg",
            alt: "",
            class: "search-area-bd__icon",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
          })
        ]),
        (_ctx.searchKey)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "search-area-ft",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
            }, "取消"))
          : _createCommentVNode("", true)
      ]),
      (_ctx.tabIndex === 0 && !_ctx.hasSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (ques, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "faq-page-link",
                onClick: ($event: any) => (_ctx.clickCategory(index))
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(ques), 1),
                _hoisted_12
              ], 8, _hoisted_10))
            }), 128)),
            _createVNode(_component_VButton, {
              class: "bottom-btn--new",
              round: "",
              block: "",
              type: "primary",
              onClick: _ctx.toAsk
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tabIndex === 1 || _ctx.hasSearch)
        ? (_openBlock(), _createBlock(_component_QuestionList, {
            key: 1,
            tabIndex: _ctx.tabIndex,
            searchKey: _ctx.trimSearchKey,
            hasSearch: _ctx.hasSearch,
            quesPage: _ctx.quesPage
          }, null, 8, ["tabIndex", "searchKey", "hasSearch", "quesPage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}